/**
 * A sign-in starts from the same clean slate a sign-out leaves.
 *
 * `logout()` clears localStorage, but closing the tab skips it — so the next
 * sign-in in a new tab boots with the previous user's tokens, persisted query
 * cache and userStore keys still in place. Root-mounted queries then fetch
 * with the old token (refreshing it over the new one if it had expired), the
 * cache rehydrates the old user's records, and the app pairs them with the new
 * user's groups: a district admin landing in "climber mode" after signing in
 * as a climber.
 *
 * This module is imported for its side effect at the top of `index.tsx`,
 * before `queryClient` and the stores, because both read localStorage the
 * moment they are evaluated. Clearing any later is too late.
 */

/** The page is the Cognito hosted UI's redirect back to the bare origin. */
export const isSignInRedirect = (): boolean =>
  window.location.pathname === "/" &&
  new URLSearchParams(window.location.search).has("code");

export const startFreshSignIn = (): void => {
  if (!isSignInRedirect()) return;
  try {
    localStorage.clear();
  } catch (error) {
    console.warn("Could not clear the previous session", error);
  }
};

startFreshSignIn();
